import { create, StoreApi, UseBoundStore } from "zustand";

type AtomStore<T> = {
    value: T;
};

export function createAtom<T = undefined>(): UseBoundStore<StoreApi<AtomStore<T | undefined>>>;
export function createAtom<T>(initialValue: T): UseBoundStore<StoreApi<AtomStore<T>>>;

export function createAtom<T>(initialValue?: T) {
    const store = create<AtomStore<T | undefined>>()(() => ({
        value: initialValue,
    }));

    return store;
}
